// Page expandableTableRowKeyText
$(document).ready(function() {
	let $control = $('.tableRowColspanFiveWithExpandableRowList a.control');

	if (!$control.length) {
		return;
	}

	$control.click(function () {
		let $this = $(this);
		let isExpanded = $this.parents('.tableRowColspanFiveWithExpandableRowList').hasClass('expanded');

		$('.tableRowColspanFiveWithExpandableRowList').removeClass('expanded');
		$('.tableRowKeyFourValues').removeClass('expanded');

		if (!isExpanded) {
			$this.parents('.tableRowColspanFiveWithExpandableRowList').addClass('expanded');
			$('.tableRowKeyFourValues[data-expandable-row-list=' + $this.data('expandable-row-list') + ']').addClass('expanded');
		}

		$('html, body').stop().animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.tableRowColspanFiveWithExpandableRowList').offset().top - 10,
		}, 700);

		return false;
	});
});
